export default "__VITE_ASSET__DIWr9s1A__"